import { createSlice } from '@reduxjs/toolkit'

const SourceSlice = createSlice({
  name: 'source',
  initialState: { list: [] },
  reducers: {
    addSource: (state, action) => {
      state.list.push(action.payload)
    },
    updateSource: (state, action) => {
      const { index, data } = action.payload
      state.list[index] = data
    },
    deleteSource: (state, action) => {
      state.list.splice(action.payload, 1)
    },
  },
})

export const { addSource, updateSource, deleteSource } = SourceSlice.actions
export default SourceSlice.reducer
